var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0.666748C12.1395 0.666748 13.3334 1.86066 13.3334 3.33341V15.3334H2.66675V0.666748H10.6667ZM10.6667 6.00008H5.33341V7.33341H10.6667V6.00008ZM9.33341 3.33341H5.33341V4.66675H9.33341V3.33341Z",
    fill: "#58606E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic_file.428e5ad5.svg";
export { ForwardRef as ReactComponent };